export const ContactAccountConst = {
  optOutColumns: ['benchNotificationOptOut', 'availabilityNotificationOptOut'],
} as const;
